import './Footer.scss';
import Logo from '../../../assets/logo.png'
import Heading from '../../sharedComponents/Heading/Heading';
import { Theme } from '../coreFiles/types';
import { useCallback, useEffect, useState } from 'react';
import { RouteItem, routes } from '../coreFiles/routes';
import { useLocation, useNavigate } from 'react-router-dom';

interface FooterProps {
    theme?: Theme;
}


interface Section {
    id: string;
    label: string;
    element: HTMLElement;
}

const Footer: React.FC<FooterProps> = ({
    theme = 'light'
}) => {
    const [activeNav, setActiveNav] = useState(routes[0].label);
    const offset = 150;

    const navigate = useNavigate();
    const location = useLocation();
    const goToContactUs = () => {
        window.scrollTo(0, 0);
        navigate("/contact");
    }

    const goToSection = (item: RouteItem) => {
        setActiveNav(item.label);
        const element = document.getElementById(item.id);

        if (element) {
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        } else {
            sessionStorage.setItem('scrollToElement', item.id);

            navigate('/');
        }
    };

    useEffect(() => {
        const scrollToElementId = sessionStorage.getItem('scrollToElement');

        if (scrollToElementId) {
            sessionStorage.removeItem('scrollToElement');

            const timeoutId = setTimeout(() => {
                const targetElement = document.getElementById(scrollToElementId);

                if (targetElement) {
                    const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth',
                    });
                }
            }, 500);

            return () => clearTimeout(timeoutId);
        }
    }, [location]);

    const debounce = (func: Function, wait: number) => {
        let timeout: NodeJS.Timeout;
        return (...args: any[]) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), wait);
        };
    };

    const handleScroll = useCallback(() => {
        const sections = routes.map(route => ({
            id: route.id,
            label: route.label,
            element: document.getElementById(route.id)
        })).filter((section): section is Section =>
            section.element !== null
        );

        let maxVisibleSection: any = null;
        let maxVisibleHeight = 0;

        sections.forEach(section => {
            const rect = section.element.getBoundingClientRect();
            const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);

            if (visibleHeight > maxVisibleHeight) {
                maxVisibleHeight = visibleHeight;
                maxVisibleSection = section;
            }
        });

        if (maxVisibleSection && maxVisibleSection.label !== activeNav) {
            setActiveNav(maxVisibleSection.label);
        }
    }, [activeNav]);

    useEffect(() => {
        const debouncedScroll = debounce(handleScroll, 100);
        window.addEventListener('scroll', debouncedScroll);

        return () => {
            window.removeEventListener('scroll', debouncedScroll);
        };
    }, [handleScroll]);

    return (
        <div id='alpha-perceptron-footer' className={`alpha-perceptron-footer ${theme}__theme`}>
            <div className='alpha-perceptron-footer__topContainer'>
                <div className='flexBox'>
                    <div className='alpha-perceptron-footer__topContainer__image'>
                        <img src={Logo} alt='AlphaPerceptron' />
                    </div>
                    <div className='alpha-perceptron-footer__topContainer__links'>
                            {routes.map((item: RouteItem) =>
                                <Heading key={item.id}
                                    onClick={() => goToSection(item)} theme={theme} size='h6' type='primary' cursor='pointer'>
                                    {item.label || 'NA'}
                                </Heading>)}
                            <Heading onClick={goToContactUs} theme={theme} size='h6' type='primary' cursor='pointer' >Contact Us</Heading>
                    </div>
                </div>
                <div className='alpha-perceptron-footer__topContainer__footerRights'>
                    <Heading theme={theme} size='h6' type='primary' >© AlphaPerceptron 2025 All Rights Reserved.</Heading>

                </div>
            </div>
            <div className={`alpha-perceptron-footer__bottomContainer ${theme}__text`}>
                AlphaPerceptron
            </div>
        </div>
    );
}

export default Footer;

